module.exports = __webpack_public_path__ + "img/thumbnail_PrzewalskisHorse_j_normal.b260e561.png";